<template>
  <div
    class="community-join-banner"
    data-test-id="community-join-banner"
  >
    <picture>
      <source
        type="image/webp"
        srcset="/common/nexus/join-the-community.webp"
      >
      <img
        src="/common/nexus/join-the-community.png"
        alt=""
        class="community-join-banner__image"
        data-test-id="community-join-banner-image"
        loading="lazy"
      >
    </picture>
    <div class="community-join-banner__content">
      <p
        class="community-join-banner__copy"
        data-test-id="community-join-banner-copy"
      >
        {{ joinBannerText }}
      </p>
      <button
        class="community-join-banner__button button"
        data-test-id="community-join-banner-button"
        @click="handleClick"
      >
        Join the community
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommunityJoinBanner',
  computed: {
    joinBannerText() {
      if (this.$site.settings.community_hub && this.$site.settings.community_hub.join_banner) {
        return this.$site.settings.community_hub.join_banner;
      }
      if (this.$site.settings.condition_name) {
        return `Become a member to find support, connections, and answers about living with ${this.$site.settings.condition_name}.`;
      }
      return '';
    },
  },
  methods: {
    handleClick() {
      this.$store.dispatch('openRegisterDialog');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_community-join-banner';
</style>
